import { extractCollection, extractPayload } from '@/utils/dataNormalization';
import { normalizeCatalogOptions } from '@/utils/catalogOptions';

const emptyOption = { value: '', label: 'Selecciona opción' };
const silentRequestConfig = {};

export const fetchSaleMultiCustomerModalCatalogs = async ({
  servicesService,
  salesService,
  areasService,
  collaboratorsService,
  tagsService,
  quotesService,
  customerId = 0,
  isEditMode = false,
}) => {
  const normalizedCustomerId = Number(customerId || 0);
  const quoteSelectorsPromise = normalizedCustomerId > 0
    ? quotesService.selectors({ company_id: normalizedCustomerId }, silentRequestConfig)
    : Promise.resolve({ data: { data: [] } });

  const statusParams = isEditMode ? {} : { is_open: 1 };

  const [
    servicesRes,
    statusesRes,
    areasRes,
    sellersRes,
    managersRes,
    tagsRes,
    quotesRes,
    quoteTypesRes,
    saleCodeRes,
  ] = await Promise.allSettled([
    servicesService.index({}, silentRequestConfig),
    salesService.statuses(statusParams, silentRequestConfig),
    areasService.index(silentRequestConfig),
    collaboratorsService.sellers({}, silentRequestConfig),
    collaboratorsService.managers({}, silentRequestConfig),
    tagsService.index({}, silentRequestConfig),
    quoteSelectorsPromise,
    quotesService.quoteTypeSelectors({}, silentRequestConfig),
    salesService.saleCode({}, silentRequestConfig),
  ]);

  const servicesRaw = servicesRes.status === 'fulfilled' ? extractCollection(servicesRes.value) : [];
  const blockedServiceTypeNames = new Set(['iguala', 'multiple cliente']);
  const filteredServices = servicesRaw.filter((service) => {
    const typeCode = String(service?.service_type_code || '').trim().toUpperCase();
    if (typeCode === 'IGL' || typeCode === 'MULT') {
      return false;
    }

    const typeName = String(service?.service_type_name || '').trim().toLowerCase();
    if (blockedServiceTypeNames.has(typeName)) {
      return false;
    }

    return true;
  });

  const statusesRaw = statusesRes.status === 'fulfilled' ? extractCollection(statusesRes.value) : [];

  const tagsRaw = tagsRes.status === 'fulfilled' ? extractCollection(tagsRes.value) : [];
  const quotesRaw = quotesRes.status === 'fulfilled' ? extractCollection(quotesRes.value) : [];
  const quoteTypesRaw = quoteTypesRes.status === 'fulfilled' ? extractCollection(quoteTypesRes.value) : [];
  const initialSaleCode = saleCodeRes.status === 'fulfilled' ? extractPayload(saleCodeRes.value) : {};

  const nextConsecutiveType = String(initialSaleCode?.consecutive_type || '').trim().toLowerCase();
  const consecutiveType = nextConsecutiveType === 'services' ? 'services' : 'general';
  const initialCode = consecutiveType === 'general' ? String(initialSaleCode?.code || '').trim() : '';

  const normalizedStatuses = normalizeCatalogOptions(statusesRaw, { useCodeInLabel: false });

  return {
    options: {
      services: normalizeCatalogOptions(filteredServices, { useCodeInLabel: false }),
      statuses: [emptyOption, ...normalizedStatuses],
      areas: [emptyOption, ...normalizeCatalogOptions(areasRes.status === 'fulfilled' ? extractCollection(areasRes.value) : [])],
      sellers: [emptyOption, ...normalizeCatalogOptions(sellersRes.status === 'fulfilled' ? extractCollection(sellersRes.value) : [])],
      managers: [emptyOption, ...normalizeCatalogOptions(managersRes.status === 'fulfilled' ? extractCollection(managersRes.value) : [])],
      quoteTypes: [emptyOption, ...normalizeCatalogOptions(quoteTypesRaw, { useCodeInLabel: false })],
      quoteCatalogs: normalizeCatalogOptions(quotesRaw, { useCodeInLabel: false }),
    },
    tagOptions: tagsRaw
      .map((tag) => String(tag?.name || '').trim())
      .filter(Boolean),
    consecutiveType,
    initialCode,
  };
};
